import Link from 'next/link';
import Button from "../ui/Button";
import type { ImageWithTextSection as ImageWithTextSectionType } from '@shared/lib/page-sections/types';

export default function ImageWithTextSection({ section }: { section: ImageWithTextSectionType }) {
  const imageOnRight = (section.imagePosition ?? 'left') === 'right';
  const imageBlock = section.imageUrl ? (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={section.imageUrl}
      alt={section.imageAlt || ''}
      className="aspect-[4/3] w-full rounded-lg object-cover"
      loading="lazy"
    />
  ) : (
    <div className="aspect-[4/3] w-full rounded-lg bg-slate-100" aria-hidden="true" />
  );

  const textBlock = (
    <div className="flex flex-col justify-center">
      {section.headline ? (
        <h2 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          {section.headline}
        </h2>
      ) : null}
      {section.body ? (
        <p className="mt-4 text-base leading-relaxed text-slate-700">{section.body}</p>
      ) : null}
      {section.ctaLabel && section.ctaHref ? (
        <div className="mt-6">
          <Button asChild variant="primary" size="md">
          <Link href={section.ctaHref}>
            {section.ctaLabel}
          </Link>
        </Button>
        </div>
      ) : null}
    </div>
  );

  return (
    <section className="w-full px-4 py-10 md:py-14">
      <div className="mx-auto grid max-w-6xl gap-8 md:grid-cols-2 md:gap-12">
        {imageOnRight ? (
          <>
            {textBlock}
            {imageBlock}
          </>
        ) : (
          <>
            {imageBlock}
            {textBlock}
          </>
        )}
      </div>
    </section>
  );
}
